module.exports = __webpack_public_path__ + "static/img/第十四届.e8b05e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/20260620/past/第十四届.png
// module id = GCu9
// module chunks = 1